import intl from "components/i18n/ReactIntlWrapper";
import { Box, Typography } from "@mui/material";

const RequiredField = () => {
  return (
    <Box>
      <Typography
        variant="body2"
        sx={{ display: "flex", justifyContent: "flex-start" }}
      >
        {intl.get("RequiredField")}
      </Typography>
    </Box>
  );
};

export default RequiredField;
